import { render, staticRenderFns } from "./setmealGoods.vue?vue&type=template&id=dbe1a994&scoped=true&"
import script from "./setmealGoods.vue?vue&type=script&lang=js&"
export * from "./setmealGoods.vue?vue&type=script&lang=js&"
import style0 from "./setmealGoods.vue?vue&type=style&index=0&id=dbe1a994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe1a994",
  null
  
)

export default component.exports